import { TSetAppBarReset, TSetAppBarTitle } from './actions.types';
import { TSetReset } from 'redux/actions';

export type TReducerState = {
    title: string;
};

export enum EActionTypes {
    SET_TITLE = 'SET_TITLE',
    APP_BAR_RESET = 'APP_BAR_RESET',
}

export type TReduxActions =
    | ReturnType<TSetAppBarTitle>
    | ReturnType<TSetAppBarReset>
    | ReturnType<TSetReset>;
